import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default ({ icon, label, className, onTap }) => {
	return (
		<motion.div
			onTap={onTap}
			className={`grid place-items-center w-[50vw] h-16 text-center text-sm font-bold rounded-full uppercase bg-yellow-500 ${className}`}>
			{label}
		</motion.div>
	);
};
